import { Button } from "@/components/Button"
import { Input } from "@/components/Form/Input"
import { CopyIcon } from "@/components/two-factor/CopyIcon"
import { DownloadIcon } from "@/components/two-factor/DownloadIcon"
import { Loading } from "@/Images"
import { copyToClipboard, IBANApi, useIBANRequisites, VALID_EMAIL } from "@usher/pe-client-front-end-lib"
import { clsx } from "clsx"
import { PropsWithChildren } from "react"
import { IBANSelect } from "../IBANSelect"
import { FormRow } from "../Payments/NewPayment/TransferForm/FormRow"
import { PageTitle } from "../Payments/sections/PageTitle"
import { PaymentSystemLogo } from "../PaymentSystemLogo"

const Row = ({ title, children }: PropsWithChildren<{ title: string }>) => {
  return (
    <div className="flex text-base py-2 flex-col md:flex-row min-h-12">
      <p className="text-gray-400 flex-1">{title}</p>
      <div className="text-black text-left flex-1 flex items-start">
        {children}
        {children && children !== "N/A" && (
          <div
            className="p-2 md:p-1  md:hover:bg-main-main ml-2 cursor-pointer text-inherit hover:text-white rounded-lg -mt-1"
            onClick={() => {
              copyToClipboard(String(children))
            }}
          >
            <CopyIcon />
          </div>
        )}
      </div>
    </div>
  )
}
export const Requisites = () => {
  const { currentIban, setCurrentIban, formModel, sendLoading, details, loading, sendRequisites } = useIBANRequisites()
  const control = formModel.control
  const isSepa = details?.currency === "EUR"
  return (
    <div className="requisites">
      <PageTitle title="Requisites" />
      <div className="max-w-full mt-[50px] md:max-w-[450px]">
        {/* @ts-ignore */}
        <IBANSelect iban={currentIban?.meta} onChange={(option) => setCurrentIban(option)} />
      </div>
      <div className={clsx("bg-white mt-[10px] relative border border-border-main")}>
        {/* {(loading || details == null) && <div className="backdrop-blur-xl inset-0 absolute bg-white/90 z-50" />} */}
        <FormRow
          title={
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center">
                <PaymentSystemLogo className="inline-block md:hidden" currency={details?.currency} />
                <span>Transfer Details ({details?.currency})</span>
                {currentIban?.value != null && <PaymentSystemLogo className="hidden md:inline-block ml-2" currency={details?.currency} />}
                {loading && <Loading className="animate-spin opacity-45" />}
              </div>
              <Button disabled={loading} onClick={() => IBANApi.downloadRequisites(currentIban?.meta, "download_requisites")}>
                <DownloadIcon /> Download
              </Button>
            </div>
          }
        >
          {/* <Row title="Amount:">{Number(details?.balance ?? 0).toFixed(2)} EUR</Row> */}
          <Row title="Account Holder's Name:">{details?.account_owner ?? "N/A"}</Row>
          {details?.account_address && <Row title="Account Holder's Address:">{details.account_address}</Row>}
          {/*<Row title="Account Holder's Country:">{details?.account_address ?? "N/A"}</Row>*/}
          <Row title="IBAN/Account No.:">{details?.account_number ?? "N/A"}</Row>
          <Row title="Swift Code:">{details?.bank_swift ?? "N/A"}</Row>
          {/*@ts-ignore*/}
          {!isSepa && details?.payment_reference && <Row title="Memo:">{details?.payment_reference}</Row>}
          {/*@ts-ignore*/}
          {details?.routing_number && <Row title="Routing Number:">{details?.routing_number ?? "N/A"}</Row>}
          {/*@ts-ignore*/}
          {details?.bank_swift_intermediary && <Row title="Intermediary Bank SWIFT Code:">{details?.bank_swift_intermediary ?? "N/A"}</Row>}
          <Row title="Bank Name:">{details?.bank_name ?? "N/A"}</Row>
          <Row title="Bank Address:">{details?.bank_address ?? "N/A"}</Row>
          {/*<Row title="Bank country:">{details?.bank_address ?? "N/A"}</Row>*/}
        </FormRow>
        <div className="flex p-[20px] gap-4 text-base flex-col items-start md:flex-row">
          <div className="mt-[-2px]">
            <p className="font-[ChakraPetchBold] text-black">Send Requisites Details</p>
            <span>Please indicate recepient email address</span>
          </div>
          <form
            noValidate
            autoComplete="off"
            className="flex gap-[10px] mt-2 md:!mt-0 md:!items-start flex-col md:flex-row text-base"
            onSubmit={formModel.handleSubmit(sendRequisites)}
          >
            <Input.Form rules={VALID_EMAIL} placeholder="Email address" className="min-w-80 text-base" required {...{ control, name: "email" }} />
            <Button loading={sendLoading} className="text-base">
              Send Requisites
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
